// extracted by mini-css-extract-plugin
export default {"syllabaryColumnItem":"CareRecipientList_syllabaryColumnItem__z+hBn","item":"CareRecipientList_item__YAfK-"};